/**
 * The characters of a word, as a reader would type them one at a time.
 *
 * One place, because two things count them and both have to agree. The grader
 * marks a typed answer character by character, and the card says how many
 * characters it wants and will not take more. A card that offered three slots
 * for a word the grader reads as two would be a card nobody could answer.
 *
 * `Array.from` rather than a spread or `split("")`, so a headword above the
 * basic plane stays one character. A 汉字 in Extension B is a surrogate pair
 * and one character to a reader.
 *
 * @param word - The headword, as the section publishes it.
 * @returns Its characters, in order.
 */
export function wordCharacters(word: string): readonly string[] {
  return Array.from(word.normalize("NFC"));
}
